export const icons = {
  get (name, css_classes) {
    let obj = this.icons[name]
    if (obj) {
      return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' + obj.viewbox + '" class="svg ' + css_classes + '">' + obj.path + '</svg>'
    } else {
      return '<!-- !load icon ' + name + ' -->'
    }
  },
  icons: {
    phone: {
      viewbox: '0 0 512 512',
      path: '<path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM200 128l-72 16 0 16c0 123.7 100.3 224 224 224h16l16-72-72-40-33.5 41.9c-34.2-18.1-62.3-46.2-80.4-80.4L240 200l-40-72z"/>'
    }
  }
}
